import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="siteFooter">
      <div className="footerInner">
        <div className="footerIdentity">
          <p className="footerTitle">
            Psychological Manipulation
          </p>

          <p className="footerDescriptor">
            Behavior · Power · Control
          </p>
        </div>

        <div className="footerContent">
          <p>
            © {currentYear} Pamela Terrell. All rights reserved.
          </p>

          <p>
            Psychological Manipulation is an independent educational project
            from{' '}
            <a
              href="https://www.stabileusa.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              StabileUSA.com
            </a>
            .
          </p>

          <p>
            This site provides educational information about psychology,
            sociology, interpersonal behavior, and coercive dynamics. It does
            not provide mental health diagnosis, psychotherapy, legal advice,
            or individualized safety assessment.
          </p>

          <p>
            About the author:{' '}
            <a
              href="https://www.pamelajterrell.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              PamelaJTerrell.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;